<template>
    <div class="sidebar__section sidebar__section--medium-vertical-padding">
        <div class="intro-text copy-light">
            <span v-for="(textitem, index) in text" :key="index" v-html="textitem.content"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: Array,
            default: () => []
        }
    }
}
</script>

<style lang="scss">
.intro-text {
    a {
        word-wrap: break-word;
    }
}
</style>